import axios from "axios";

/**
 * @param {{ activity_drawer_width_px?: number; team_people_panel_width_px?: number }} payload
 */
export function persistPanelColumnWidths(payload) {
    return axios.patch("/user-states/panel-column-widths", payload);
}
